export const MainConfig = {
    AppDetails: {
        app_name: "Call A ride", 
        app_description: "Digital Taxi",
        app_identifier: "com.jekalo",
        ios_app_version: "1.0.0", 
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyDTCPVhoeqHxZKqc9GM9Ljgla_tbeoEZ1k",
        authDomain: "callaride-2ba3c.firebaseapp.com",
        databaseURL: "https://callaride-2ba3c-default-rtdb.firebaseio.com",
        projectId: "callaride-2ba3c",
        storageBucket: "callaride-2ba3c.appspot.com",
        messagingSenderId: "925886070701",
        appId: "1:925886070701:web:c6a2006eb30616c853eb24",
        measurementId: "G-995JFWHBX3"
    },
    Google_Map_API_Key: {
        ios: "AIzaSyBS-es9dBCgGFeYIpxF8o96EsrhtrUEoDU",
        android: "AIzaSyBS-es9dBCgGFeYIpxF8o96EsrhtrUEoDU",
        web: "AIzaSyBonAyHYyB8vOUjyjP7eIf5W9Cqj7fxtZU"
    },
    facebookAppId: "1652344391660384",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "ec6e6a5a-bafb-4405-9610-d3df2fc4e79b",
        Buyer_Email_Address: "contactbolarinwa@gmail.com"
    }
}